import initCustomSelect from '@/scripts/lib/select';

const defaults = {
  element: null,
  select: '[data-role*="select"]',
};

export default class Form {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    this.element = options.element;
    if (!this.element) return;
    this.selectSelector = options.select;
    this.selects = null;
    this.init();
  }

  init() {
    this.selects = Array // eslint-disable-line no-unused-vars
      .from(this.element.querySelectorAll(this.selectSelector))
      .map(el => initCustomSelect(el));
  }
}




// WEBPACK FOOTER //
// ./scripts/blocks/contact-form.js